module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc7-b0ad2287ba028ee33571b481aa947eef.jpg";